<template>
  <div class="app-container">
    <el-button
      size="medium"
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/patrol/path_add')"
      >添加</el-button
    >
    <el-button
      size="medium"
      type="info"
      @click="downloadFile()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/equipment/template')"
      >下载模板</el-button
    >
    <el-button
      size="medium"
      type="success"
      @click="leadIn()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/patrol/path_import_template')"
      >导入</el-button
    >
    <!-- <el-button type="info" circle icon="el-icon-refresh"  style="font-size: 14px;cursor: pointer;float: right;" @click="fetchData()"></el-button> -->
    <el-button
      size="medium"
      type="primary"
      plain
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      size="medium"
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >

    <el-input
      style="float: right; width: 200px"
      v-model="screen.name"
      placeholder="请输入巡检路线的名称"
    ></el-input>
    <el-select
      filterable
      style="float: right"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="园区" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="路线名称" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/patrol/path_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/patrol/path_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="60%"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @opened="openDrawer"
    >
      <el-form
        label-position="top"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype != 'add' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="路线名称" prop="name">
          <el-input
            class="w4"
            v-model="ruleForm.name"
            placeholder="请输入路线名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            class="w4"
            v-model="ruleForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检路线" prop="status">
          <el-button @click="choosePatrol()" class="xjdBtn" type="primary"
            >选择巡检点</el-button
          >
          <el-table
            class="courseTable"
            ref="dragTable"
            row-key="id"
            :data="courseList"
            :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
            style="width: 100%"
          >
            <el-table-column prop="name" label="地点名称" width="280">
              <template slot-scope="scope">
                <div class="line2">{{ scope.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column label="二维码" width="180">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.qrcode"
                  class="tableIcon"
                  alt=""
                  srcset=""
                  :src="imageUrl + scope.row.qrcode"
                />
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="info"
                  @click="courseDel(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
      <el-drawer
        size="50%"
        title="巡检点列表"
        :append-to-body="true"
        :before-close="handleClose"
        :visible.sync="innerDrawer"
        :row-class-name="tableRowClassName"
      >
        <el-table
          ref="dragTable"
          :data="inspectionList"
          style="width: 100%"
          :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          @selection-change="innerSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column prop="name" label="园区">
            <template slot-scope="scope">
              <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="地点名称">
            <template slot-scope="scope">
              <div class="line2">{{ scope.row.name }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="btnBox">
          <div>
            <el-button type="success" @click="confirmInspection()"
              >确定</el-button
            >
            <el-button type="info" @click="innerDrawer = false">取消</el-button>
          </div>

          <el-pagination
            :page-size="15"
            @current-change="inspectionChange"
            background
            layout="prev, pager, next"
            :total="inspectionTotal"
          >
          </el-pagination>
        </div>
      </el-drawer>
    </el-drawer>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/patrol/path_import_template'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccess"
        :on-progress="beforeAvatarUpload"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { mapGetters } from "vuex";
import {
  pathLists,
  addPath,
  infoPath,
  editPath,
  delPath,
  openPark,
  positionLists,
  templatetPath,
  path_template,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      token: getToken(),
      innerDrawer: false,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        name: "",
      },
      total: 0,
      ruleForm: {
        park_id: "",
        name: "",
        patrol_position_ids: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入路线名称", trigger: "blur" }],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
      },
      multipleSelection: [],
      innerSelection: [],
      cztype: "",
      parkList: [],
      courseList: [],
      inspectionList: [],
      inspectionTotal: 0,
      inspectionPage: 1,
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.screen.type = this.userInfo.type;
    } else {
      this.screen.park_id = "";
    }
    if (this.userInfo.company_id !== 0) {
      this.screen.company_id = this.userInfo.company_id;
    } else {
      this.screen.company_id = "";
    }
    this.fetchData();
    this.getpark();
  },
  methods: {
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUpload(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      path_template().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    // 创建sortable实例
    initSortable() {
      // 获取表格row的父节点
      const ele = this.$refs.dragTable.$el.querySelector(
        ".el-table__body > tbody"
      );
      var _this = this;
      // 创建拖拽实例
      let dragTable = Sortable.create(ele, {
        animation: 150, //动画
        dragClass: "dragClass", //设置拖拽样式类名
        ghostClass: "ghostClass", //设置拖拽停靠样式类名
        chosenClass: "chosenClass", //设置选中样式类名
        // 开始拖动事件
        onStart: () => {},
        // 结束拖动事件
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.courseList.splice(oldIndex, 1)[0];
          _this.courseList.splice(newIndex, 0, currRow);
          // 创建新数组
          const tableArray = [];
          _this.courseList.forEach((item) => {
            tableArray.push(item.id);
          });
        },
      });
    },
    // 设置表格row的class
    tableRowClassName({ row }) {
      return "";
    },
    openDrawer() {
      this.$refs.ruleForm.clearValidate();
      this.initSortable();
    },
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        name: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
        this.screen.type = this.userInfo.type;
      } else {
        this.screen.park_id = "";
      }
      if (this.userInfo.company_id !== 0) {
        this.screen.company_id = this.userInfo.company_id;
      } else {
        this.screen.company_id = "";
      }
      this.fetchData();
    },
    // 选择巡检点
    choosePatrol() {
      if (!this.ruleForm.park_id) {
        this.$message.error("请选择园区");
        return;
      } else {
        this.getInspection();
        this.innerDrawer = true;
      }
    },
    courseDel(index) {
      this.courseList.splice(index, 1);
    },
    // 确定选择巡检点
    confirmInspection() {
      this.courseList = this.courseList.concat(this.innerSelection);
      this.innerDrawer = false;
    },
    // 多选巡检点
    innerSelectionChange(val) {
      this.innerSelection = val;
    },
    getInspection() {
      const ids = [];
      this.courseList.forEach((item) => {
        ids.push(item.id);
      });
      positionLists({
        park_id: this.ruleForm.park_id,
        not_ids: ids.toString(),
        page: this.inspectionPage,
        status: 1,
      }).then((res) => {
        this.inspectionList = res.data.lists.data;
        this.inspectionTotal = res.data.lists.total;
      });
    },
    inspectionChange(val) {
      this.inspectionPage = val;
      this.getInspection();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const ids = [];
          that.courseList.forEach((item) => {
            ids.push(item.id);
          });
          that.ruleForm.patrol_position_ids = ids.toString();
          this.$confirm("确认提交？")
            .then(() => {
              editPath(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      // this.oldImg = val.avatar_url
      this.getInfo(val.id, val.park_id);
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id, val.park_id);
      this.drawer = true;
    },
    // 获取信息
    getInfo(id, parkId) {
      var that = this;
      infoPath({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          park_id: res.data.info.park_id,
          remark: res.data.info.remark,
        };
        this.courseList = res.data.info.patrol_position_lists;
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delPath({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const ids = [];
          that.courseList.forEach((item) => {
            ids.push(item.id);
          });
          that.ruleForm.patrol_position_ids = ids.toString();
          this.$confirm("确认提交？")
            .then(() => {
              addPath(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch((_) => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        des: "",
        name: "",
        park_id: "",
        status: 1,
      };
      this.courseList = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.drawer = true;
    },
    // 获取园区
    getpark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    delPatrol() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then(() => {
          delPath({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      pathLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.xjdBtn {
  float: right;
  margin-top: -40px;
}
.btnBox {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// 拖拽
.dragClass {
  background: rgba($color: #41c21a, $alpha: 0.5) !important;
}
// 停靠
.ghostClass {
  background: rgba($color: #6cacf5, $alpha: 0.5) !important;
}
// 选择
.chosenClass:hover > td {
  background: rgba($color: #f56c6c, $alpha: 0.5) !important;
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
</style>
